<template>
    <div class="d-flex flex-row">
        <AdminHead />
        <div>
            <h1>这是首页</h1>
        </div>
    </div>

</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import AdminHead from '@/components/AdminHead.vue';
export default defineComponent({
    components: {
        AdminHead,
    }
})
</script>